import script from "./ShareholdersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareholdersView.vue?vue&type=script&setup=true&lang=ts"

import "./ShareholdersView.vue?vue&type=style&index=0&id=70dbfe0b&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70dbfe0b"]])

export default __exports__